/* src/app/expenses/features/expense-entry/expense-entry-feature.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=expense-entry-feature.component.css.map */
